
































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ServerResult } from "@/core/http/server_result";
import moment from "moment";

const REPORT_DATA = "PRODUCTION_FORECAST_LOG";

@Component
export default class ProductionForecastLog extends Vue {
  @Prop() row!: any;

  loading: boolean = false;
  facts: any[] = [];
  history: any[] = [];
  planCalculatedQuantity: number | null = null;

  mounted() {
    this.loadData();
  }

  loadData() {
    const vm = this as any;
    this.loading = true;

    vm.$db([
      vm
        .$q(REPORT_DATA)
        .raw("production_forecast_log")
        .action({
          plan_ids: this.row.plan_ids,
          date_from: this.row.date_from,
          date_to: this.row.date_to,
        }),
    ]).then((result: ServerResult) => {
      const payload = result.getOperation(REPORT_DATA).getContent()
        .documents[0];

      this.facts = payload ? payload.facts || [] : [];
      this.history = payload ? payload.history || [] : [];
      this.planCalculatedQuantity =
        payload && payload.plan_calculated_quantity != null
          ? Number(payload.plan_calculated_quantity)
          : null;
      this.loading = false;
    });
  }

  get productLabel(): string {
    const r = this.row;
    if (!r) return "";
    const name = this.resolveString(r.product_name);
    const container = this.resolveString(r.product_container_name);
    const parts = [name, container].filter(Boolean);
    return parts.length ? parts.join(" ") : "—";
  }

  resolveString(v: any): string {
    if (v == null) return "";
    if (typeof v === "string") return v;
    if (typeof v === "object" && v !== null && "name" in v)
      return String((v as any).name ?? "");
    return String(v);
  }

  formatNum(value: any): string {
    const n = value != null ? Number(value) : NaN;
    if (Number.isNaN(n)) return "—";
    const filters = this.$options.filters as any;
    return filters?.numFormat ? filters.numFormat(n, "0,0.00") : String(n);
  }

  /** Подсветка строки, по которой взят максимум для расчёта (учёт тары: quantity в кг). */
  isUsedForCalculation(row: any): boolean {
    if (this.planCalculatedQuantity == null) return false;
    const q = Number(row.quantity);
    const ref = Number(this.planCalculatedQuantity);
    if (Number.isNaN(q) || Number.isNaN(ref)) return false;
    return Math.abs(q - ref) < 0.01;
  }

  /** Тип изменения на русском для вкладки История изменений */
  changeTypeLabel(changeType: string | null | undefined): string {
    if (!changeType) return "";
    const map: Record<string, string> = {
      calculated: "Расчёт",
      manual_update: "Ручное изменение",
      date_transfer: "Перенос даты",
      date_transfer_in: "Перенос на дату (приход)",
      date_transfer_out: "Перенос с даты (уход)",
    };
    return map[String(changeType).toLowerCase()] ?? changeType;
  }

  getWeekNum(row: any): number {
    if (row?.week_num != null && row?.week_num !== "") {
      return Number(row.week_num);
    }
    const m = moment(row?.week_wednesday || row?.date);
    return m.isValid() ? m.isoWeek() : 0;
  }

  buildFactsDateLink(row: any): string {
    const date = row?.week_wednesday || row?.date;
    const clientId = this.row?.client_id || this.row?.id;
    return `/deals?clientId=${clientId}&dates=${date}&dates=${date}&status=d%3Astatuses%3A16`;
  }

  close() {
    this.$emit("close");
  }
}
